import { useLazyQuery } from '@apollo/client/react';
import { LoggerContextProps } from '../types/LogContext';
import { LIST_CHATS } from '../queries/ListChats';
import { Chat } from '../types/Chat';
import { handleError } from './errorHandler';

export function useListChats() {
  const context: LoggerContextProps = {
    action: 'listChats',
    caseId: '',
  };
  const [listChatsQuery, { data, loading, error }] = useLazyQuery<{
    listChats: {
      items: Chat[];
    };
  }>(LIST_CHATS, {
    fetchPolicy: 'network-only',
  });
  const fetchChats = async (id: string) => {
    context.caseId = id;
    try {
      await listChatsQuery({
        variables: {
          filter: {
            case_id: id,
          },
        },
      });
    } catch (error) {
      handleError(error, context, `Failed to list chats.`);
    }
  };

  return { fetchChats, data, loading, error };
}
